import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { AppRouters } from '@/utils/constants/routers';

import LoginPage from '@/pages/auth/login';
import RegisterPage from '@/pages/auth/register';
import ForgotPasswordPage from '@/pages/forgotPassword';
import ProfilePage from '@/pages/profile';
import MunicipalityPage from '@/pages/municipality';
import AdminPage from '@/pages/admin';
import TranslatePanelPage from '@/pages/translatePanel';
import HomePage from '@/pages/home';
import { PrivateRoute } from '@/components/organisms/route/private';
import { PublicRoute } from '@/components/organisms/route/public';
import { PrivateAdminRoute, PublicAdminRoute } from '@/components/organisms/route/admin';
import PlanManagementPage from '@/pages/planManagement';
import ChatKnowledgePage from '@/pages/chatKnowledge';
import ChatPage from '@/pages/chat';
import UsersPage from '@/pages/users';
import ProjectAnalysisListPage from '@/pages/projectAnalysis';
import ProjectAnalysisViewerPage from '@/pages/projectAnalysis/viewer';
import ProjectAnalysisAdminPage from '@/pages/projectAnalysisAdmin';
import ProjectAnalysisAdminReportPage from '@/pages/projectAnalysisAdmin/report';
import BigQuerySyncPreviewPage from '@/pages/bigQuerySyncPreview';

export const Routes = () => {
  return (
    <RouterRoutes>
      {/* Private Routes */}
      <Route
        index
        element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        }
      />
      <Route
        path={AppRouters.profile}
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route path={AppRouters.municipality}>
        <Route
          path=":cdMun"
          element={
            <PrivateRoute>
              <MunicipalityPage />
            </PrivateRoute>
          }
        />
      </Route>

      <Route
        path={AppRouters.projectAnalysis}
        element={
          <PrivateRoute>
            <ProjectAnalysisListPage />
          </PrivateRoute>
        }
      />
      <Route
        path={`${AppRouters.projectAnalysis}/:reportId`}
        element={
          <PrivateRoute>
            <ProjectAnalysisViewerPage />
          </PrivateRoute>
        }
      />

      {/* Public Routes */}
      <Route
        path={AppRouters.login}
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path={AppRouters.register}
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />
      <Route
        path={AppRouters.forgotPassword}
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
      />

      {/* Admin Public Routes */}
      <Route
        path={AppRouters.admin}
        element={
          <PublicAdminRoute>
            <AdminPage />
          </PublicAdminRoute>
        }
      />

      {/* Admin Private Routes */}
      <Route
        path={AppRouters.translatePanel}
        element={
          <PrivateAdminRoute>
            <TranslatePanelPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.planManagement}
        element={
          <PrivateAdminRoute>
            <PlanManagementPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.chatKnowledge}
        element={
          <PrivateAdminRoute>
            <ChatKnowledgePage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.chat}
        element={
          <PrivateAdminRoute>
            <ChatPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.users}
        element={
          <PrivateAdminRoute>
            <UsersPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.bigQuerySyncPreview}
        element={
          <PrivateAdminRoute>
            <BigQuerySyncPreviewPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={AppRouters.projectAnalysisAdmin}
        element={
          <PrivateAdminRoute>
            <ProjectAnalysisAdminPage />
          </PrivateAdminRoute>
        }
      />
      <Route
        path={`${AppRouters.projectAnalysisAdmin}/:reportId`}
        element={
          <PrivateAdminRoute>
            <ProjectAnalysisAdminReportPage />
          </PrivateAdminRoute>
        }
      />
    </RouterRoutes>
  );
};
